// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"styles_tabsWrapper__Dqc5P","tabsRow":"styles_tabsRow__HOWW6"};